import { h, Component } from "preact";
import { gettext as _ } from "../../utils/i18n";
import lazy_component from "../../utils/lazy_component";

const ReportModal = lazy_component(() => import("./ReportModal"));

interface Props {
    id: number;
}

interface State {
    is_modal_open: boolean;
}

export default class ReportButton extends Component<Props, State> {
    constructor(props) {
        super(props);

        this.state = {
            is_modal_open: false,
        };
    }

    handle_modal_open = () => {
        this.setState({
            is_modal_open: true,
        });
    };

    handle_modal_close = () => {
        this.setState({
            is_modal_open: false,
        });
    };

    render(props: Props, state: State) {
        const msg_title = _("Report");

        return (
            <button className="muted" title={msg_title} onClick={this.handle_modal_open}>
                <svg className="icon mr-1">
                    <use xlinkHref="#flag"></use>
                </svg>
                <span className="d-none d-md-inline">{msg_title}</span>
                {state.is_modal_open && (
                    <ReportModal id={props.id} is_open={state.is_modal_open} onClose={this.handle_modal_close} />
                )}
            </button>
        );
    }
}
